export const STORAGE_KEY = "LAST_SELECT_WORKSPACE_ID";
export const DURATION = 14;
export const USER_TYPE = {
  ADMINISTRATOR: "ADMINISTRATOR",
  DEVELOPER: "DEVELOPER",
};

export const ROLE_TYPE = {
  OWNER: "OWNER",
  MEMBER: "MEMBER",
};

export const POD_STATUS = {
  running: "Running",
  loading: "Loading",
  created: "Created",
  stop: "STOP",
  shutdown: "Shutdown",
  restart: "Restart",
  resume: "Resume",
  restarting: "Restarting",
  failed: "Failed",
  installing: "Installing",
  updating: "Updating",
  resourcing: "Resourcing",
  terminating: "Terminating",
  pending: "Pending",
  preparing: "Preparing",
};

export const UNIT_LABELS = {
  MiliCores: "mi",
  Core: "core",
  MebiByte: "MiB",
  KibiByte: "KiB",
  GibiByte: "Gi",
  Byte: "Byte",
};

export const DATE_FORMAT = {
  FULL: "YYYY-DD-MM HH:mm",
  SORT: "DD-MM HH:mm",
  HOUR_MINUTE_ONLY: "HH:mm",
  DAY_MONTH_ONLY: "DD-MMM",
};

export const WORKSPACE_ROLE = {
  ADMINISTRATOR: "administrator",
  MEMBER: "member",
};

export const CI_TEMPLATE_TYPES = [
  "SPRINGBOOT",
  "DOCKER",
  "GO",
  "VUEJS",
  "REACT",
  "NEXTJS",
  "NEXACRO",
  "WEBSQUARE",
];

export const CI_TEMPLATE_ONLY_BATCH = ["SPRINGBOOT", "DOCKER", "GO"];
